import { CanActivateFn, Router } from '@angular/router';
import { AppRoutes } from 'src/app/app.routes';
import { AuthService } from './auth.service';
import { inject } from '@angular/core';

export function authGuard(): CanActivateFn {
    return () => {
        const authService: AuthService = inject(AuthService);
        const router: Router = inject(Router);

        if (authService.isLoggedIn()) {
            return true;
        }

        return router.parseUrl(AppRoutes.Start.toString());
    };
}